import { useMemo } from 'react';
import {
  Lesson,
  DailyRosterInstructor,
  LessonDetailsData
} from '@/constants/Interfaces/CommonInterfaces';
import { toHHmm } from '@/utils/common';

export const useLessonDetails = (
  lesson: Lesson,
  instructor: DailyRosterInstructor
) => {
  const lessonDetails = useMemo((): LessonDetailsData => {
    // Parse lesson times
    const startTime = toHHmm(lesson.start) || 'N/A';
    const endTime = toHHmm(lesson.end) || 'N/A';

    // Extract lesson code
    const lessonCode = lesson.lesson_code?.code || 'N/A';

    // Get counts
    const amCount = lesson.am || 0;
    const pmCount = lesson.pm || 0;
    const fdCount = lesson.fd || 0;

    // Get transport/vehicle information
    const transportName =
      lesson.transport?.name ||
      lesson.transports?.name ||
      lesson.car?.name ||
      lesson.vehicle?.name ||
      'N/A';

    // Get mountain information
    const mountainName = lesson.mountain?.name || 'N/A';

    // Get hotel information (if available)
    const hotelName = lesson.hotel?.name || 'N/A';

    // Get agent information (if available)
    const agentName = lesson.agent?.name || 'N/A';

    // Get reference number (if available)
    const refNumber = lesson.reference || 'N/A';

    // Get payment status (if available)
    const paymentStatus = lesson.paid === 'Y' ? 'YES' : 'NO';

    // Get comments (if available)
    const comments = lesson.comments || 'No comments available';

    return {
      instructor: instructor.name,
      string: lesson?.string || 'N/A',
      client: lesson.client_name || 'N/A',
      lesson: lessonCode,
      am: amCount,
      pm: pmCount,
      fd: fdCount,
      level: lesson.ski_level || 'N/A',
      start: startTime,
      end: endTime,
      hotel: hotelName,
      car: transportName,
      pickUpTime: lesson?.pickup_time || 'N/A', // Using start time as pick-up time for now
      mountain: mountainName,
      agent: agentName,
      ref: refNumber,
      paid: paymentStatus,
      lesson_req: lesson.lesson_req || 'NA',
      transport_pax: lesson?.transport_pax,
      comments
    };
  }, [lesson, instructor]);

  return lessonDetails;
};
